import React from "react";
import moment from 'moment';
import { Link,Redirect } from "react-router-dom";
import {getData} from '../../services/index';
import { Tabs ,Modal} from 'antd';
import { StickyContainer, Sticky } from 'react-sticky';
import 'antd/dist/antd.css';

const { TabPane } = Tabs;

class Index extends React.Component {
	static contextTypes = {
        router: () => null
    };
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			visible: false,
		}
		this.logout = this.logout.bind(this);
	}

	componentWillMount() {
		document.querySelector(".loader-wrapper").style = "display: none";
		setTimeout(() => {
			document.querySelector(".loader-wrapper").style = "display: none";
		}, 500);
		if(!localStorage.getItem('schoolData')) {
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login';
		}
	}
	
	showModal = () => {
		this.setState({
		  visible: true,
		});
	  };

	  handleOk = () => {
		this.setState({ loading: true });
		setTimeout(() => {
		  this.setState({ loading: false, visible: false });
		}, 3000);
	  };

	  handleCancel = () => {
		this.setState({ visible: false });
	  };
	  
	  logout(){
			localStorage.setItem("schoolData",'');
			localStorage.clear();
			window.location.href = '/login/';
		}

	render() {
	
	const { visible, loading } = this.state;	
		return (
			<div class="mobile_view">
			
			
      
      <div id="main" class="bg-off">		
         <div class="row">
		 
			
		<div class="col s12 m12 ex-padd">
            <div id="breadcrumbs-wrapper" class="bg-off">
               <div class="">
                  <div class="row no-margin">
				  <div class="col s12 m12 header-title mt-20 mh-40 iq-card">
					<div class="col s12 m6 l6 pb-15 mt-5">
                        <h5 class="breadcrumbs-title"><span class="back_arrow" onClick={this.context.router.history.goBack}><i class="ri-arrow-left-circle-line"></i></span><span class="main_title">Time Table</span></h5>
                     </div>
                     
                     <div class="col s12 m6 l6 right-align-md pt-10">
                          <ol class="breadcrumbs mb-0">
                           <li class="breadcrumb-item"><a href="/">Home</a>
                           </li>
						   
						  
                           <li class="breadcrumb-item active">Time Table
                           </li>
                        </ol>
                     </div>
                     </div>
                  </div>
               </div>
            </div>
            </div>	
		 
		 
            <div class="col s12 col-xs-12 pd0 home">
               <div class="container">
                  <div class="section">
                    
   <div class="col s12 m12 mt-10">
      <div class="time-table-mobile">
         
         <div class="card-body pt-0">
            <div class="col s12 row borders pd7 tt">
				
			   
			   <Link to={`${process.env.PUBLIC_URL}/time-table/manage`}>
			   <div class="col m3 s6">
					<div class="card gradient-45degs-green-teal border-radius-20 animate fadeUp mt-0">
						<div class="card-content row no-margin br-5">
							<div class="col m4 s12 mobile-center">
									<img src="assets/icons/clock.png"
									   class="sub-img" alt="image" />
							</div>
							<div class="col m8 s12 mobile-center">
										<h5 class="sub-title pl-0">Manage<br/>Time Table</h5>
							</div>
						</div>
					</div>
				</div>
			   </Link>
			   
			    
			   
			   <Link to={`${process.env.PUBLIC_URL}/time-table/list`}>
			   <div class="col m3 s6">
					<div class="card gradient-45degs-green-teal border-radius-20 animate fadeUp mt-0">
						<div class="card-content row no-margin br-5">
							<div class="col m4 s12 mobile-center">
									<img src="assets/icons/clock.png"
									   class="sub-img" alt="image" />
							</div>
							<div class="col m8 s12 mobile-center">
										<h5 class="sub-title pl-0">Add<br/>Time Table</h5>
							</div>
						</div>
					</div>
				</div>
			   </Link>

			   <Link to={`${process.env.PUBLIC_URL}/time-table/review`}>
			   <div class="col m3 s6">
					<div class="card gradient-45degs-green-teal border-radius-20 animate fadeUp mt-0">
						<div class="card-content row no-margin br-5">
							<div class="col m4 s12 mobile-center">
									<img src="assets/icons/clock.png"
									   class="sub-img" alt="image" />
							</div>
							<div class="col m8 s12 mobile-center">
										<h5 class="sub-title pl-0">Review Teacher <br/>Timetable</h5>
							</div>
						</div>
					</div>
				</div>
			   </Link>
			    
			  
               
            </div>
         </div>
      </div>
   </div>

                  </div>
               </div>
            </div>
            <div class="content-overlay"></div>       
      </div>
      </div>
     

			</div>
		) 
	} 
}
export default Index;
